import React, { useState } from 'react';
import { authHeaderOrEmpty } from '../../utils/authHeaders';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CHAMPS = [
  { cle: 'carte_pro_numero', label: 'Carte professionnelle n°', aide: 'Transactions sur immeubles et fonds de commerce' },
  { cle: 'carte_pro_cci', label: 'Délivrée par la CCI de', aide: 'Ville de la chambre de commerce' },
  { cle: 'garant_financier', label: 'Garantie financière', aide: 'Organisme et montant' },
  { cle: 'rcs', label: 'RCS', aide: 'Ville et numéro d’immatriculation' },
];

/**
 * lot DA — Mentions légales reprises en en-tête du bon de visite.
 * Un champ laissé vide n'apparaît pas sur le document.
 */
export const AgencyMentionsLegalesCard = ({ agence, onSaved }) => {
  const [valeurs, setValeurs] = useState(() =>
    Object.fromEntries(CHAMPS.map((c) => [c.cle, agence?.[c.cle] || ''])));
  const [busy, setBusy] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const enregistrer = async () => {
    setBusy(true);
    setFeedback(null);
    try {
      const res = await fetch(`${API_URL}/api/my-agence/mentions-legales`, {
        method: 'PUT',
        headers: { ...authHeaderOrEmpty(), 'Content-Type': 'application/json' },
        body: JSON.stringify(valeurs),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Erreur lors de l'enregistrement");
      onSaved?.(valeurs);
      setFeedback({ type: 'success', text: 'Mentions légales enregistrées.' });
    } catch (err) {
      setFeedback({ type: 'error', text: err.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6" data-testid="agence-mentions-legales-card">
      <div className="mb-5">
        <h2 className="text-lg font-bold text-slate-800">Mentions légales</h2>
        <p className="text-sm text-slate-500 mt-0.5">
          Reprises en en-tête du bon de visite. Un champ laissé vide n’apparaît pas sur le document.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {CHAMPS.map((c) => (
          <div key={c.cle}>
            <label className="block text-sm font-semibold text-slate-700 mb-1" htmlFor={`mention-${c.cle}`}>
              {c.label}
            </label>
            <input
              id={`mention-${c.cle}`}
              value={valeurs[c.cle]}
              onChange={(e) => setValeurs((v) => ({ ...v, [c.cle]: e.target.value }))}
              data-testid={`agence-mention-${c.cle}`}
              className="w-full h-11 px-3 text-base border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
            <p className="text-xs text-slate-400 mt-1">{c.aide}</p>
          </div>
        ))}
      </div>

      {feedback && (
        <p
          className={`mt-4 text-sm ${feedback.type === 'error' ? 'text-red-600' : 'text-emerald-600'}`}
          data-testid="agence-mentions-feedback"
        >
          {feedback.text}
        </p>
      )}

      <button
        onClick={enregistrer}
        disabled={busy}
        data-testid="agence-mentions-save-btn"
        className="mt-5 px-4 h-11 rounded-lg bg-emerald-500 hover:bg-emerald-600 disabled:opacity-60 text-white font-medium"
      >
        {busy ? 'Enregistrement…' : 'Enregistrer'}
      </button>
    </div>
  );
};

export default AgencyMentionsLegalesCard;
